import styled from "styled-components";

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.netural100};
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    margin-top: 40px;
  }
`;

export const PrimaryText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primary300};
  text-align: center;
  margin-bottom: 40px;
  max-width: 418px;
  padding: 0 16px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(24, 30, 45, 0.05),
    0px 0px 10px 0px rgba(64, 56, 95, 0.05),
    0px 0px 40px 0px rgba(81, 94, 108, 0.05);
  border-radius: 8px;
  padding: 40px;
  max-width: 636px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h2`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin-bottom: 24px;
`;

export const Description = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #5d646b;
  text-align: center;
  margin-bottom: 24px;
`;

export const Subtitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #5d646b;
  text-align: center;
`;

export const QRSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin-top: 16px;
  margin-bottom: 40px;
`;

export const QRCode = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StoreSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 416px;
`;

export const StoreButtons = styled.div`
  display: flex;
  gap: 30px;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    gap: 16px;
  }
`;